import React, { useEffect, useState } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from '@mui/material';
import axios from 'axios';

const EditTaskPopup = ({ taskId, onClose }) => {
  const [taskData, setTaskData] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Fetch task details
    axios.get(`/api/edittasks.php?id=${taskId}`)
  .then((res) => {
    const data = Array.isArray(res.data) ? res.data[0] : res.data;
    setTaskData(data);
  })
  .catch(console.error);

    // Fetch users
    axios.get(`/api/users.php`)
      .then((res) => setUsers(res.data))
      .catch(console.error);
  }, [taskId]);

  const handleSubmit = () => {
    axios.put(`/api/edittasks.php`, {
      ...taskData,
    }).then(() => {
      onClose(); // Close popup after saving
      window.location.reload();
    }).catch(console.error);
  };

  if (!taskData) return null;

  return (
    <div className="fixed inset-0  bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-md shadow-md w-[600px] max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">Edit Task</h2>
        <form className="space-y-4">
          <TextField
            fullWidth
            label="Task Name"
            size="small"
            value={taskData.task_name}
            onChange={(e) => setTaskData({ ...taskData, task_name: e.target.value })}
          />

          <div className="flex gap-4 mt-4">
            <TextField
              fullWidth
              label="Client Name"
              size="small"
              value={taskData.client_name || ''}
              onChange={(e) => setTaskData({ ...taskData, client_name: e.target.value })}
            />
            <TextField
              fullWidth
              type="date"
              label="Start Date"
              size="small"
              value={taskData.start_date}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setTaskData({ ...taskData, start_date: e.target.value })}
            />
          </div>

          <div className="flex gap-4">
            <FormControl fullWidth size="small">
              <InputLabel>Assign By</InputLabel>
              <Select
                value={taskData.assign_by}
                label="Assign By"
                onChange={(e) => setTaskData({ ...taskData, assign_by: e.target.value })}
              >
                {users.map((user) => (
                  <MenuItem key={user.id} value={user.name}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth size="small">
              <InputLabel>Assign To</InputLabel>
              <Select
                value={taskData.assign_to}
                label="Assign To"
                onChange={(e) => setTaskData({ ...taskData, assign_to: e.target.value })}
              >
                {users.map((user) => (
                  <MenuItem key={user.id} value={user.name}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth size="small">
              <InputLabel>Priority</InputLabel>
              <Select
                value={taskData.priority}
                label="Priority"
                onChange={(e) => setTaskData({ ...taskData, priority: e.target.value })}
              >
                <MenuItem value="Medium">Medium</MenuItem>
                <MenuItem value="Urgent">Urgent</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="flex gap-4">
            <TextField
              fullWidth
              label="Tentative Time"
              type="number"
              size="small"
              value={taskData.submission_date || ''}
              onChange={(e) => setTaskData({ ...taskData, submission_date: e.target.value })}
            />
            <TextField
              fullWidth
              label="Submission Date"
              type="date"
              size="small"
              value={taskData.due_date || ''}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setTaskData({ ...taskData, due_date: e.target.value })}
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" sx={{ background: '#374151' }} onClick={handleSubmit}>
              Save Task
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTaskPopup;
